import React, { Component } from 'react';
import createHistory from 'history/createHashHistory';//路由切换地址
import Crumbs from './../../../Crumbs/Crumbs';//面包屑
const history = createHistory();//定义history路由
class App extends React.Component {

    componentDidMount() {
        history.push({
            pathname: "/Content/Business/CompanyList",
        })
    }
    render() {
        return (
            <div>
                <Crumbs title={"主体管理 / 主体设置"} />
            </div>
        );
    }
}

export default App


// WEBPACK FOOTER //
// ./src/components/Content/Business/CompanyCenter/CompanyRouter/testrouter.js